import React, { useContext } from 'react';
import Fade from 'react-reveal/Fade';
import { Container } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';

const Contact = () => {
  const { contact } = useContext(PortfolioContext);
  const { cta, btn, email } = contact;

  return (
    <section id="contact">
      <Container>
        <Title title="Get in touch" />
        <Fade bottom duration={1000} delay={800} distance="30px">
          <div className="contact-wrapper">
            <p className="contact-wrapper__text">
              {cta || "If you'd like to get in touch. Please fill out the form and I'll get back to you ASAP! Alternatively, call me on 07834 488380."}
            </p>
          </div>
        </Fade>
      </Container>
    </section>
  );
};

export default Contact;
